import React from 'react';
import PropTypes from 'prop-types';

// assets
import StyledImgIcon from './styles';

const ImgIcon = (props) => {
  const { icon, alt, height, width } = props;

  return <StyledImgIcon src={icon} alt={alt} height={height} width={width} />;
};

ImgIcon.defaultProps = {
  icon: '',
  alt: '',
  width: 0,
  height: 0,
};
ImgIcon.propTypes = {
  icon: PropTypes.shape({}),
  alt: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ImgIcon;